<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-forgot">
      <p class="title">パスワードの再設定</p>

      <div class="description">
        <p>パスワードを忘れてしまった場合はご登録頂いているメールアドレスへ、パスワード再発行リンクを記載したメールをお送り致します。</p>
      </div>

      <PaFrontForm
        :action="'/'"
        :formSet="formSet"
        :submitText="'再発行'"
        :submitLoading="submitLoading"
        
        @handleSubmit="handleSubmit"
      />
    </div>
  </section>
</template>

<script>
import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FormValidationControlMixin,
    FrontPageMixins
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      submitLoading : false,
      formSet       : {
        email       : {
          label           : 'メールアドレス',
          description     : ' \
          <p>ご登録頂いているメールアドレスを入力してください。</p> \
          <p>Twtterログイン等でのみ登録されている場合はパスワードの再発行はご利用できません。</p> \
          ',
          validationRules : ['notEmpty', 'email', 'max'],
        }
      }
    };
  },

  methods : {
    async handleSubmit(){
      this.submitLoading = true;

      if(this.checkFormPreValidation()){
        this.disabledFields();

        const results = await this.$store.dispatch({
          type  : 'requests/registration/resetPasswordRequest',
          email : this.formSet['email']['value']
        });

        const validationResult = await this.RESTResultResultValidationGuard(results);

        this.submitLoading = false;
        this.unDisabledFields();

        if(validationResult === true){
          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;ご登録のメールアドレスにパスワード再設定URLをお送りいたしました。万一、メールが届かない場合はご登録されていない可能性があります。',
            status      : 'primary',
            hasControl  : true,
            autoClose   : 10000
          }, {root:true});

          return this.$router.push({name: 'index'});
        }
      }

      this.submitLoading = false;
      this.unDisabledFields();

      this.flashMessageToScroll({
        status    : 'error',
        text      : '&nbsp;入力項目にエラーが存在します。今一度ご確認ください。',
        autoClose : 1800,
        cancelBtn : false,
      });
    }
  },
  async mounted(){
    await this.initializePage();
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/globals.scss";

.pa-section{
  &-registration{
    .pa-forgot{
      
    }
  }
}
</style>